// extracted by mini-css-extract-plugin
export default {"l_ArrowIcon_main":"ArrowIcon_l_ArrowIcon_main__uxx0S","l_img":"ArrowIcon_l_img__E40-P"};